import React from 'react';
import ReactDOM from 'react-dom';
import {PublicClientApplication} from '@azure/msal-browser';
import {MsalProvider} from '@azure/msal-react';
import {Provider} from 'react-redux';
import {ThemeProvider} from '@mui/material';
import {msalConfig} from './util/auth';
import './index.scss';
import App from './modules/App';
import {store} from './store';
import {theme} from './muiTheme';

export const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </MsalProvider>,
  document.getElementById('root')
);
